import React, { useState } from 'react'
import SelectField from '@modules/formFields/SelectField'
import { ScheduleModal } from '@modules/admin/groups/components/specialitiesScheduleModal'

const SpecialitiesSchedulesField = ({ isDefaultGroup, options, ...props }) => {
  const { value, onChange } = props.input
  const [selectedSpeciality, setSelectedSpeciality] = useState(null)
  const saveSchedule = (schedules) => {
    onChange(addScheduleOnSpeciality(schedules))
    setSelectedSpeciality(false)
  }
  const addScheduleOnSpeciality = (schedules) => {
    return value.map((speciality) => {
      if (speciality.id === selectedSpeciality.id) return { ...speciality, schedules }
      return speciality
    })
  }
  return (
    <>
      {selectedSpeciality && (
        <ScheduleModal
          selectedSpeciality={selectedSpeciality}
          hide={() => setSelectedSpeciality(null)}
          onChange={saveSchedule}
          isDefaultGroup={isDefaultGroup}
        />
      )}
      <SelectField {...props} options={options} />

      {/* {!!value?.length &&
      <>
        <Label>{"Horarios de especialidades asignadas"}</Label>
        <Table
          columns={specialityColumns}
          rows={createSpecialityRows({columns:specialityColumns, rows: value,onRemove:removeElement,onSelect:speciality=>setSelectedSpeciality(speciality)})}/>
      </>

      }*/}
    </>
  )
}
export default SpecialitiesSchedulesField
